export default "__VITE_ASSET__D5ZlPEK$__"